import { EmployeeDto } from "./employee.dto";
import { PaginatorInfo } from "./generic.dto";
import { PayPeriodDto } from "./pay-period.dto";
import { SalaryAdvanceGroupDto } from "./salary-advance-group.dto";

type SalaryAdvance = {
  id: number;
  employeeId: number;
  startPayPeriodId: number;
  amount: number
  createdAt: Date;
  modifiedAt: Date | null;
}

export class CreateSalaryAdvanceDto {
  employeeId!: number
  startPayPeriodId!: number
  amount!: number
  groupId?: number
}

export class UpdateSalaryAdvanceDto {
  startPayPeriodId?: number
  amount?: number
  groupId?: number
}

export interface SalaryAdvanceDto extends SalaryAdvance {
  employee?: EmployeeDto;
  startingPayPeriod?: PayPeriodDto;
  group?: SalaryAdvanceGroupDto;
}

export interface SalaryAdvancePaginator extends PaginatorInfo<SalaryAdvanceDto> {}

export class QuerySalaryAdvanceDto {
  employeeId?: number
  startPayPeriodId?: number
  companyId?: number
  groupId?: number
  page: number = 1;
  limit?: number;
  orderBy: SalaryAdvanceOrderBy = SalaryAdvanceOrderBy.CREATED_AT_ASC;
}

export enum SalaryAdvanceOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc'
}


export class UploadSalaryAdvancesResponse {
  successful!: {
    salaryAdvanceId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}

export interface QuerySalaryAdvanceNoPaginationDto extends Omit<QuerySalaryAdvanceDto, 'page' | 'limit'> {};

export class ExportSalaryAdvanceQueryDto {
  employeeNumber?: boolean;
  startPayPeriodCode?: boolean;
  amount?: boolean;
  groupCode?: boolean;
  orderBy: SalaryAdvanceOrderBy = SalaryAdvanceOrderBy.CREATED_AT_ASC;
}